import { getDate } from 'app/rm/erp/common/utils/date-utils';
import { ErpArrivalValue, ErpReturnTripValue, ErpTransportationValue, ErpTravelZoneValue }
    from '../../shared/model/travelmanagement-values';

export interface TravelItineraryBackend {
    id?: number;
    readonly objGuid?: string;
    readonly lockVersion?: number;

    tripBeginDate?: number;
    tripEndDate?: number;

    arrivalSelected?: ErpArrivalValue;
    returnTripSelected?: ErpReturnTripValue;

    origin?: string;
    destination?: string;

    transportationSelected?: ErpTransportationValue;
    distance?: number;
    emissions?: number;
    compensationAmount?: number;
    travelZoneSelected?: ErpTravelZoneValue;
    reason?: string;
}

export class TravelItinerary {
    id?: number;
    readonly objGuid?: string;
    readonly lockVersion?: number;

    tripBeginDate?: Date;
    tripEndDate?: Date;

    arrivalSelected?: ErpArrivalValue;
    returnTripSelected?: ErpReturnTripValue;

    origin?: string;
    destination?: string;

    transportationSelected?: ErpTransportationValue;
    distance?: number;
    emissions?: number;
    compensationAmount?: number;
    travelZoneSelected?: ErpTravelZoneValue;
    reason?: string;
}

export class TravelItineraryFactory {
    static createFromBackendModel( backendModel: TravelItineraryBackend ): TravelItinerary {
        const frontendModel: TravelItinerary = {
            id: backendModel.id,
            objGuid: backendModel.objGuid,
            lockVersion: backendModel.lockVersion,

            tripBeginDate: getDate( backendModel.tripBeginDate ),
            tripEndDate: getDate( backendModel.tripEndDate ),

            arrivalSelected: backendModel.arrivalSelected,
            returnTripSelected: backendModel.returnTripSelected,

            origin: backendModel.origin,
            destination: backendModel.destination,

            transportationSelected: backendModel.transportationSelected,
            distance: backendModel.distance,
            emissions: backendModel.emissions,
            compensationAmount: backendModel.compensationAmount,
            travelZoneSelected: backendModel.travelZoneSelected,
            reason: backendModel.reason
        };
        return frontendModel;
    }

    static createFromFrontendModel( frontendModel: TravelItinerary ): TravelItineraryBackend {
        const backendModel: TravelItineraryBackend = {
            id: frontendModel.id,
            objGuid: frontendModel.objGuid,
            lockVersion: frontendModel.lockVersion,

            tripBeginDate: frontendModel.tripBeginDate?.getTime(),
            tripEndDate: frontendModel.tripEndDate?.getTime(),

            arrivalSelected: frontendModel.arrivalSelected,
            returnTripSelected: frontendModel.returnTripSelected,

            origin: frontendModel.origin,
            destination: frontendModel.destination,

            transportationSelected: frontendModel.transportationSelected,
            distance: frontendModel.distance,
            emissions: frontendModel.emissions,
            compensationAmount: frontendModel.compensationAmount,
            travelZoneSelected: frontendModel.travelZoneSelected,
            reason: frontendModel.reason
        };
        return backendModel;
    }
}

export interface TravelItineraryWithPosition {
    position: number;
    travelItinerary: TravelItinerary;
    isNewElement: boolean;
}
